import type en from '../en/starlink'
import type { Translation } from '../types'

/** Starlink: the terminals, a site's and an event's cards, the business account */
const starlink: Translation<typeof en> = {
  "starlink.title": "Starlink-terminals",
  "starlink.subtitle": "De Starlink-terminals van het bedrijf: hun locatie of evenement, online, dataverbruik en hun service",
  "starlink.search": "Starlink-terminals zoeken",
  "starlink.refresh": "Vernieuwen",
  "starlink.refreshed": "Starlink-accounts gelezen",
  "starlink.refreshFailed": "De Starlink-accounts zijn niet gelezen",
  "starlink.addByKit": "Toevoegen op kitserienummer",
  "starlink.addHint": "Een terminal met een persoonlijk abonnement, zonder zakelijk account: deze toont wat Velanox ervan weet — de locatie en het verhuuritem.",
  "starlink.kitSerial": "Kitserienummer",
  "starlink.nickname": "Naam (optioneel)",
  "starlink.add": "Toevoegen",
  "starlink.added": "Starlink toegevoegd",
  "starlink.addFailed": "Starlink niet toegevoegd",
  "starlink.none": "Nog geen Starlink-terminals. Voeg het zakelijke account van het bedrijf toe onder Bedrijfsinstellingen → Verbindingen, of voeg een terminal toe op kitserienummer.",
  "starlink.col.terminal": "Terminal",
  "starlink.col.site": "Locatie of evenement",
  "starlink.col.online": "Online",
  "starlink.col.data": "Data",
  "starlink.col.service": "Service",
  "starlink.online": "Online",
  "starlink.offline": "Offline",
  "starlink.lastRead": "Laatst gelezen {when}",
  "starlink.notRead": "Nog niet gelezen",
  "starlink.noAccount": "Geen account",
  "starlink.notListed": "Niet meer in het account",
  "starlink.data": "{used} van {plan} GB",
  "starlink.dataNoLimit": "{used} GB",
  "starlink.serviceOn": "Aan",
  "starlink.serviceOff": "Uit",
  "starlink.serviceUnknown": "Onbekend",
  "starlink.switching": "Bezig met schakelen…",
  "starlink.event": "Evenement: {name}",
  "starlink.linkToSite": "Aan locatie koppelen",
  "starlink.site": "Locatie",
  "starlink.noSite": "Geen locatie",
  "starlink.linked": "Starlink gekoppeld",
  "starlink.linkFailed": "Starlink niet gekoppeld",
  "starlink.save": "Opslaan",
  "starlink.remove": "Verwijderen",
  "starlink.removeConfirm": "{name} verwijderen? Een terminal die nog in het account staat, komt bij de volgende keer lezen terug, zonder locatie.",
  "starlink.removed": "Starlink verwijderd",
  "starlink.removeFailed": "Starlink niet verwijderd",
  "starlink.card.lastSeen": "Laatst gezien {when}",
  "starlink.card.neverSeen": "Nooit iets ontvangen",
  "starlink.card.alerts": "De schotel meldt: {alerts}",
  "starlink.card.data": "Data deze factuurperiode",
  "starlink.card.noLimit": "Het abonnement heeft geen datalimiet",
  "starlink.card.noData": "Geen dataverbruik bekend",
  "starlink.card.service": "Service",
  "starlink.card.onConfirm": "De service van deze Starlink aanzetten? Daar kunnen kosten aan verbonden zijn.",
  "starlink.card.offConfirm": "De service van deze Starlink uitzetten?",
  "starlink.card.switched": "Service geschakeld",
  "starlink.card.switchFailed": "Service niet geschakeld",
  "starlink.card.inApp": "Schakel deze in de Starlink-app: het abonnement kan hier niet worden gepauzeerd.",
  "starlink.card.pending": "Starlink heeft het schakelen nog niet uitgevoerd: het wordt elke 5 minuten opnieuw geprobeerd.",
  "starlink.card.noAccount": "Geen zakelijk account: gebruik de Starlink-app voor het dataverbruik en de service.",
  "starlink.eventCard.none": "Geen Starlink-terminals op dit evenement.",
  "starlink.eventCard.switchedOn": "Aangezet",
  "starlink.eventCard.switchedOff": "Uitgezet",
  "starlink.eventCard.notTaken": "niet uitgevoerd door Starlink",
  "starlink.eventCard.withEvent": "met het evenement",
  "starlink.eventCard.by": "door {name}",
  "starlink.eventCard.noSwitches": "Nog niet geschakeld voor dit evenement",
  "starlink.account.title": "Zakelijk Starlink-account",
  "starlink.account.intro": "De client-ID en het secret van een serviceaccount van het zakelijke Starlink-account van het bedrijf. Velanox leest de terminals elke 5 minuten en schakelt hun service met uw evenementen.",
  "starlink.account.name": "Naam",
  "starlink.account.clientId": "Client-ID",
  "starlink.account.clientSecret": "Client secret",
  "starlink.account.secretKept": "Laat leeg om het secret te behouden",
  "starlink.account.save": "Testen en opslaan",
  "starlink.account.saved": "Starlink-account opgeslagen",
  "starlink.account.terminals": "Terminals",
  "starlink.edit": "Bewerken",
  "starlink.saved": "Starlink opgeslagen",
  "starlink.saveFailed": "Starlink niet opgeslagen",
  "starlink.dish.title": "Starlink-schotel",
  "starlink.dish.auto": "Automatisch",
  "starlink.dish.wan": "Alleen {wan}",
  "starlink.dish.off": "Uit",
  "starlink.dish.lookAgain": "Opnieuw zoeken",
  "starlink.dish.looking": "Zoeken…",
  "starlink.dish.found": "Gevonden op {wan}",
  "starlink.dish.notFound": "Geen Starlink gevonden achter deze router",
  "starlink.dish.failed": "Regels konden niet worden geschreven: {reason}",
  "starlink.dish.turnedOff": "Velanox zoekt geen Starlink-schotel achter deze router",
  "starlink.dish.notChanged": "De instelling voor de Starlink-schotel is niet gewijzigd",
  "starlink.dish.block": "Schotel",
  "starlink.dish.signalOk": "Signaal goed",
  "starlink.dish.signalLow": "Signaal zwak",
  "starlink.dish.obstructed": "Belemmerd {pct}%",
  "starlink.dish.obstructedNow": "nu belemmerd",
  "starlink.dish.speed": "Download {down} · Upload {up} Mbps",
  "starlink.dish.latency": "Vertraging {ms} ms",
  "starlink.dish.drop": "{pct}% van de pings verloren",
  "starlink.dish.stowed": "Opgeborgen",
  "starlink.dish.reachedVia": "Bereikt via {site}",
  "starlink.dish.notReachedSince": "Niet bereikt sinds {when}",
  "starlink.dish.notReached": "Niet bereikt",
  "starlink.dish.reboot": "Herstarten",
  "starlink.dish.stow": "Opbergen",
  "starlink.dish.unstow": "Uitklappen",
  "starlink.dish.rebootConfirm": "Deze schotel herstarten? De verbinding valt een paar minuten weg.",
  "starlink.dish.stowConfirm": "Deze schotel opbergen? Hij klapt plat en de verbinding stopt.",
  "starlink.dish.unstowConfirm": "Deze schotel uitklappen?",
  "starlink.dish.done": "Naar de schotel gestuurd",
  "starlink.dish.actionFailed": "De schotel heeft het niet gedaan",
}

export default starlink
